import { connect } from "react-redux";
import { getTicketsForRacesInCurrentTournament } from "../selectors";
import ImportPicksButton from "../components/import-picks-button";

function select(state, props) {
  return {
    ticketsForRacesInCurrentTournament: getTicketsForRacesInCurrentTournament(state, props)
  };
}

export default connect(select, {})(ImportPicksButton);


